'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var state = {
  /*换肤*/
  skin: {},
  /*POST请求携带token*/
  token: false,
  datumValue: 4,
  datumObj: 2,
  /*菜单选中key*/
  menuActiveName: '',
  /*菜单自动展开key*/
  menuOpenName: [],
  /*页码数*/
  pageSize: 10,
  /*大模态框状态（已废弃）*/
  modelDisabled: true,
  /*面包屑*/
  crumbsList: [],
  /*菜单列表*/
  menuList: [],
  // 用户名和头像
  userChangeInfo: {},
  /*不显示头routername */
  hideRouterName: ['loading', 'toonLogin', 'oauthLogin', 'play', 'playVideo', 'questionnairepaper', 'paper', 'paperresult', 'exampractice', 'retrieve', 'resetPasswords', 'resetPhone', 'bindPhone', 'exercise', 'qusetionnaireresult', 'certificate-detail', 'examcertificateDetail', 'livePlay', 'validPhone', 'certificateQuery', 'dxExamNotice', 'dxpaper', 'dxpaperresult', 'dxExamRecord', 'dxExamResult', 'dxparsepaper'],
  /*设置特定router背景颜色 */
  bgRouter: {
    '#eee': ['paper', 'paperresult', 'qusetionnaireresult', 'dxExamResult'],
    '#2d2d2e': ['play']
  },
  /* 资源列表-帮助手册选中状态 */
  helpSelected: false,
  /*将免过滤请求设置黑名单，防止token异常*/
  filterFreeRequests: ['user/validateCaptcha', 'user/event/visit', 'api-message/portal/sms/open/generatePhoneCode', 'api-ouser/portal/user/open/account/resetPasswd', 'api-message/portal/sms/open/validPhoneCode', 'api-ouser/portal/user/open/getBindAccount', 'api-ouser/portal/user/open/getLoginUser'],
  /*不登录可访问页面-name*/
  filterLoginPage: ['loading', // 中转页面
  // 'toonLogin', // 北京市统一身份认证登录
  // 'toonUnified', // 统一认证返回信息
  // 'bjouUnified', // 北开
  'login', // 登录
  'index', 'logintest', 'retrieve', 'registerPhone', 'bandingPhone', // 绑定手机
  'bandingOk', // 绑定成功
  'agreement', // 协议
  'dxExamRecord', 'dxExamNotice', 'dxparsepaper', 'dxpaper', 'dxExamResult', 'microLesson-whitelist', 'pdfpreview',
  // 'index', // 首页
  'course-list', // 课程超市
  'course-detail', // 课程超市详情
  // 'course-topics', // 课程专题
  'activityCenter', // 活动中心
  'activityCenterDetail', // 活动中心详情
  'activityCenterReviewActive', // 活动中心精彩回顾详情
  'experienceBase', // 基地列表
  'experienceBaseDetail', // 基地列表详情
  'dynamicList', // 学习资讯
  'dynamicDetail', // 资讯详情
  'notice-list', // 通知公告
  'message-detail', // 通知公告详情
  'learnMap', // 学习地图
  'agedUnivercity', // 老年大学
  'project-list', // 培训项目
  'project-detail', // 培训详情
  'studyStarList', // 学习之星列表
  'studyStarDetail', // 学习之星详情
  'concatDetail', // 联系我们
  'play', // 播放页
  'playVideo', // 播放页
  'certificateQuery', // 证书查询
  'channelColumn', // 品牌栏目
  'columnInformationDetail', // 资讯栏目详情
  'resultsShow', // 专题频道
  'teacherDetail', // 师资详情
  'columnsAll', // 推荐专栏更多
  'resources', // 资源中心,
  'jingcaizhibo', 'jingcaizhibo-list' // 京彩直播列表
  ],
  // 手机认证/实名认证等提示状态
  flushContent: '',
  // refresh login success notify
  /**
   * NOTIFY_LOGIN_SUCCESS_REFRESH_USER_INFO: 通知登录成功后刷新用户信息
   */
  loginSuccessNotify: ''
};
exports.default = state;